import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AppStateService } from '../../../shared/services/app-state.service';

@Injectable({
  providedIn: 'root'
})
export class SccGuard  {

  constructor(private readonly appStateService: AppStateService, private readonly router: Router) {
  }

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.appStateService.isScc) {
      void this.router.navigate(['']);
      return false;
    }

    return true;
  }
}
